import EmptyState from '@atlaskit/empty-state'
import PropTypes from 'prop-types'
import errorImg from '../../static/img/error-window.svg'

export function NotFound() {
  return (
    <EmptyState
      description='That link has no power here'
      header='404 Not Found'
      imageUrl={errorImg}
    />
  )
}

Error.propTypes = {
  primaryAction: PropTypes.node,
  maxImageHeight: PropTypes.number,
}
